module.exports = __webpack_public_path__ + "static/media/blueEmail.3e808e8b.svg";